import { render } from "./ListChannels.vue?vue&type=template&id=5b94c3e8&ts=true"
import script from "./ListChannels.vue?vue&type=script&lang=ts"
export * from "./ListChannels.vue?vue&type=script&lang=ts"

import exportComponent from "/root/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__